var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-2" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.esignBizForm.bizTypeName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.esignBizForm.bizVoucherNo))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.esignBizForm.fstPartyRealComName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.esignBizForm.sndPartyRealComName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.esignBizForm.fileToSignGenerated == false ? "未生成" : ""
                ) +
                "\n                "
            ),
            _vm.esignBizForm.fileToSignGenerated == false
              ? _c(
                  "a",
                  { staticClass: "font-blue", on: { click: _vm.toGenFile } },
                  [_vm._v("生成待签署文件")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.esignBizForm.fileToSignGenerated == true
              ? _c(
                  "a",
                  { staticClass: "font-blue", on: { click: _vm.toGenFile } },
                  [_vm._v("查看")]
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(6),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.esignBizForm.fileToSignStatusDesc) +
                "\n                "
            ),
            _vm.esignBizForm.fileToSignStatus == 0 ||
            _vm.esignBizForm.fileToSignStatus == 3
              ? _c(
                  "a",
                  { staticClass: "font-blue", on: { click: _vm.toUploadFile } },
                  [_vm._v("上传待签署文件")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.esignBizForm.fileToSignStatus == 1
              ? _c("a", {
                  staticClass: "el-icon-refresh",
                  on: { click: _vm.uploadResult }
                })
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(7),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-2" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(8),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.esignBizForm.initiatorPhoneNo) +
                "\n            "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(9),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.esignAuthenStateMap[
                      _vm.esignBizForm.initiatorAuthenState
                    ]
                  )
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(10),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _vm.esignBizForm.signFlowStatus == 0
                ? [
                    _c(
                      "el-radio",
                      {
                        attrs: {
                          label: false,
                          disabled: _vm.allowUpFlow == false
                        },
                        model: {
                          value: _vm.esignBizForm.sndPartySignFirst,
                          callback: function($$v) {
                            _vm.$set(_vm.esignBizForm, "sndPartySignFirst", $$v)
                          },
                          expression: "esignBizForm.sndPartySignFirst"
                        }
                      },
                      [_vm._v("甲方先签")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      {
                        attrs: {
                          label: true,
                          disabled: _vm.allowUpFlow == false
                        },
                        model: {
                          value: _vm.esignBizForm.sndPartySignFirst,
                          callback: function($$v) {
                            _vm.$set(_vm.esignBizForm, "sndPartySignFirst", $$v)
                          },
                          expression: "esignBizForm.sndPartySignFirst"
                        }
                      },
                      [_vm._v("乙方先签")]
                    )
                  ]
                : [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.esignBizForm.sndPartySignFirst == true
                            ? "乙方先签"
                            : "甲方先签"
                        )
                      )
                    ])
                  ]
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(11),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _vm.esignBizForm.signFlowStatus == 0
                ? [
                    _c("el-switch", {
                      attrs: { disabled: _vm.allowUpFlow == false },
                      model: {
                        value: _vm.esignBizForm.fstPartyAutoSign,
                        callback: function($$v) {
                          _vm.$set(_vm.esignBizForm, "fstPartyAutoSign", $$v)
                        },
                        expression: "esignBizForm.fstPartyAutoSign"
                      }
                    })
                  ]
                : [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.esignBizForm.fstPartyAutoSign == true
                            ? "是"
                            : "否"
                        )
                      )
                    ])
                  ]
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(12),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.esignBizForm.sndPartyAutoSign == true ? "是" : "否")
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _vm.esignBizForm.fstPartyAutoSign == true
              ? _c("label", [_vm._v("甲方签署印章：")])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _vm.esignBizForm.fstPartyAutoSign == true
              ? _c("div", [
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.esignBizForm.fstEsignDefSealName || "") +
                        "\n                        "
                    ),
                    _vm.allowUpFlow
                      ? _c("div", {
                          staticClass:
                            "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                          attrs: { title: "选择" },
                          on: {
                            click: function($event) {
                              _vm.selectSealInfo()
                            }
                          }
                        })
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticStyle: { width: "100px", height: "100px" },
                    attrs: { src: _vm.esignBizForm.fstEsignDefSealImageUrl },
                    on: {
                      click: function($event) {
                        _vm.showSealImage(
                          _vm.esignBizForm.fstEsignDefSealImageUrl
                        )
                      }
                    }
                  })
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _vm.esignBizForm.sndPartyAutoSign == true
              ? _c("label", [_vm._v("乙方签署印章：")])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _vm.esignBizForm.sndPartyAutoSign == true
              ? _c("div", [
                  _c("div", [
                    _vm._v(_vm._s(_vm.esignBizForm.sndEsignDefSealName || ""))
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticStyle: { width: "100px", height: "100px" },
                    attrs: { src: _vm.esignBizForm.sndEsignDefSealImageUrl },
                    on: {
                      click: function($event) {
                        _vm.showSealImage(
                          _vm.esignBizForm.sndEsignDefSealImageUrl
                        )
                      }
                    }
                  })
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(13),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.esignBizForm.fstPartyRealComName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(14),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [_vm._v(_vm._s(_vm.esignBizForm.sndPartyRealComName))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(15),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.esignAuthenStateMap[
                      _vm.esignBizForm.fstPartyOrgAuthState
                    ]
                  )
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(16),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.esignAuthenStateMap[
                      _vm.esignBizForm.sndPartyOrgAuthState
                    ]
                  )
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _vm.esignBizForm.fstPartyAutoSign == false
              ? _c("label", [_vm._v("甲方签署人手机号：")])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _vm.esignBizForm.fstPartyAutoSign == false
              ? _c("span", [
                  _vm._v(_vm._s(_vm.esignBizForm.fstPartyTransactorPhoneNo))
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(17),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [
              _vm._v(" " + _vm._s(_vm.esignBizForm.sndPartyTransactorPhoneNo))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _vm.esignBizForm.fstPartyAutoSign == false
              ? _c("label", [_vm._v("甲方签署人认证状态：")])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _vm.esignBizForm.fstPartyAutoSign == false
              ? _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.esignAuthenStateMap[
                          _vm.esignBizForm.fstPartyTransactorAuthenState
                        ]
                      )
                  )
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(18),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.esignAuthenStateMap[
                      _vm.esignBizForm.sndPartyTransactorAuthenState
                    ]
                  )
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.esignBizForm.signFlowStatus > 0
        ? [
            _c(
              "div",
              { staticClass: "content-caption dashed" },
              [
                _c("span", [_vm._v("签署结果")]),
                _vm._v(" "),
                _vm.esignBizForm.signFlowStatus == 3 ||
                _vm.esignBizForm.signFlowStatus == 5 ||
                _vm.esignBizForm.signFlowStatus == 7
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { float: "right" },
                        attrs: { type: "primary" },
                        on: { click: _vm.esignAgain }
                      },
                      [_vm._v("重新发起签署\n            ")]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "simple-form flex col-2" }, [
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(19),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.signFlowStatusMap[_vm.esignBizForm.signFlowStatus]
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm.esignBizForm.signFlowStatus == 1
                    ? _c("a", {
                        staticClass: "el-icon-refresh",
                        on: { click: _vm.refreshSignFlowStatus }
                      })
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(20),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _vm.esignBizForm.signFlowStatus == 2
                    ? _c("span", [
                        _vm._v(_vm._s(_vm.esignBizForm.signFlowEndTime))
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group center" }, [
                _vm._m(21),
                _vm._v(" "),
                _c("div", { staticClass: "form-value width-1-5x" }, [
                  _vm.esignBizForm.signedFileUuid == null
                    ? _c("span", [_vm._v("暂无")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.esignBizForm.signedFileUuid != null
                    ? _c(
                        "a",
                        {
                          staticClass: "font-blue",
                          on: {
                            click: function($event) {
                              _vm.toViewFile(_vm.esignBizForm.signedFileUuid)
                            }
                          }
                        },
                        [_vm._v("下载")]
                      )
                    : _vm._e()
                ])
              ])
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("单据信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("单据类型：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("单据编号：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("甲方公司：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("乙方公司：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("待签署文件：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("上传状态：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("签署方信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发起人手机号：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发起人认证状态：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("签署顺序：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("甲方自动签署：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("乙方自动签署：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("甲方公司：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("乙方公司：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("甲方公司认证状态：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("乙方公司认证状态：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("乙方签署人手机号：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("乙方签署人认证状态：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("签署状态：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("签署日期：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("已签署文件：")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1eba3bd3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eba3bd3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/EsignBizFormInfo.vue
// module id = 2988
// module chunks = 0